<template>
  <div id="app">
    <auth v-if="enableAuth" />
    <app-header/>
    <router-view/>
    <app-footer/>
    <background />
  </div>
</template>

<script>
import axios from 'axios'
import Auth from '@/components/Auth'
import AppHeader from '@/components/Header'
import AppFooter from '@/components/Footer'
import Background from '@/components/Background'

import { Plugins } from '@capacitor/core'
const { App, Device, SplashScreen } = Plugins

export default {
  components: {
    Auth,
    AppHeader,
    AppFooter,
    Background
  },
  data() {
    return {
      enableAuth: true
    }
  },
  methods: {
    async getDeviceInfo () {
      const info = await Device.getInfo()
      this.$store.commit('SET_DEVICE_INFO', info)
    },
    async getDeviceLanguage () {
      const languageCode = await Device.getLanguageCode()
      this.$store.commit('SET_DEVICE_LANGUAGE', languageCode)
    },
    getStops () {
      axios.get(`${process.env.VUE_APP_API_URL}/stops`)
        .then(response => {
          this.$store.commit('SET_STOPS', response.data)
          this.hideSplashScreen()
        })
    },
    hideSplashScreen () {
      SplashScreen.hide()
    },
    registerBackButton () {
      App.addListener('backButton', () => {
        const currentRoute = this.$router.currentRoute.name
        if (currentRoute === 'favorites' || currentRoute === 'stops') {
          App.exitApp()
        } else {
          this.$router.push('/stops')
        }
      })
    }
  },
  created() {
    this.getStops()
    this.getDeviceInfo()
    this.getDeviceLanguage()
    this.registerBackButton()
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/global.scss';
@import '@/assets/scss/_fonts.scss';

#app {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}
</style>
